import React from 'react'

const HoroscopeBox=(props)=>{
    const blank = 'No data';
    return (
        <div>
            <h6>{props.title}</h6>
            <p>{props.data?props.data:blank}</p>
        </div>
    )
}

export default HoroscopeBox
